import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest} from "@elements/dom-utils";

let backdrop = document.querySelectorAll('.js-backdrop')[0];
let mainNav = document.querySelectorAll('.js-side-nav')[0];
let mainNavToggler = document.querySelectorAll('.js-side-nav__main-toggle')[0];

let sideItem = document.querySelectorAll('.js-side-item');
let sideitemToggle = document.querySelectorAll('.js-side-item__toggle');

export function init() {
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            sideitemToggle.forEach(function (toggler) {
                if (hasClass('open', toggler)) {
                    toggler.click();
                    setTimeout(() => {
                        //timeout because of animation
                        toggler.focus();
                    }, 350);
                }
                if (hasClass('open', mainNavToggler)) {
                    mainNavToggler.click();
                    setTimeout(() => {
                        //timeout because of animation
                        mainNavToggler.focus();
                    }, 350);
                }
            });
        }
    });

    /* nav toggle opens sidenav */
    onFind('.js-side-item__toggle', function (button) {
        on('click', function () {
            //close main nav, man nav toggler, sideitems and sideitem toggler
            removeClass('open', mainNav);
            removeClass('open', mainNavToggler);
            mainNavToggler.setAttribute('aria-expanded', 'false');

            sideItem.forEach(function (item) {
                removeClass('open', item);
            });

            //get attribute data-side-item and open the item
            let item = button.getAttribute('data-side-item');
            let itemEl = document.querySelectorAll('.js-side-item[data-side-item="' + item + '"]')[0];

            if(!hasClass('open', button)) {
                sideitemToggle.forEach(function (element) {
                    removeClass('open', element);
                });
                addClass('open', button);
                addClass('open', backdrop);
                addClass('open', itemEl);
                itemEl.setAttribute('tabindex', '-1');
                button.setAttribute('aria-expanded', 'true');
                setTimeout(() => {
                    //timeout because of animation
                    itemEl.focus();
                }, 350);
                if(item === 'search') {
                    setTimeout(() => {
                        //timeout because of animation
                        document.querySelectorAll('.js-autocomplete')[0].focus();
                    }, 350);
                }
            } else {
                removeClass('open', button);
                removeClass('open', itemEl);
                removeClass('open', backdrop);
                itemEl.removeAttribute('tabindex');
                button.setAttribute('aria-expanded', 'false');
                itemEl.blur();
                if (item === 'search') {
                    document.querySelectorAll('.js-autocomplete')[0].blur();
                }
            }
        }, button);
    });


    if(_config.openLogin) {
        let toggler = document.querySelectorAll('.js-side-item__toggle[data-side-item="myboesch"]')[0];
        let login = document.querySelectorAll('.js-side-item[data-side-item="myboesch"]')[0];
        addClass('open', toggler);
        addClass('open', backdrop);
        addClass('open', login);
        toggler.setAttribute('aria-expanded', 'true');
    }


    /* close sideitems */
    onFind('.js-side-item__close', function (closebutton) {
        on('click', function () {
            let sideItem = closest('.js-side-item', closebutton);
            let toggler = document.querySelectorAll('.js-side-item__toggle[data-side-item="myboesch"]')[0];

            sideitemToggle.forEach(function (element) {
                removeClass('open', element);
            });

            removeClass('open', sideItem);
            removeClass('open', backdrop);
            removeClass('open', mainNav);
            removeClass('open', mainNavToggler);
            mainNavToggler.setAttribute('aria-expanded', 'false');
            //toggler.setAttribute('tabindex', '-1');
            //toggler.focus();
        }, closebutton);
    });
}